<template>
    <div class="wrap">
        <div class="scoreHead">给一尘会员【{{ name || "--" }}】评分，该会员得分{{ t }}</div>
        <div class="scoreNum">
            打分：<input class="input" min="1" v-model="scoreNumber" max="100" maxlength="3" placeholder="请输入分数"
                type="tel"> <span>注：最低1分，最高100分</span>
        </div>
        <div class="scoreAddressTitle">评分交易地址:</div>
        <div class="adressDesc">
            {{ url }}

            <div class="descTip">交易地址为当前帖子链接，不可修改</div>
        </div>
        <div class="scoreAddressTitle">交易评价:</div>
        <div class="adressDesc">
            <textarea v-model="evaluationContent" class="areatext" name="" id=""></textarea>
        </div>

        <div style="margin: 16px;">
            <van-button round block type="info" @click="handleScoreSubmit" :disabled="isloading"
                native-type="submit">提交评分</van-button>
        </div>
    </div>
</template>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<script>
import { addRatingScore } from '@/api/base';
export default {
    components: {
    },
    data() {
        return {
            isloading: false,
            type: '',
            url: '',
            name: '',
            t: '',
            userId: '',
            scoreNumber: null,
            evaluationContent: '合作愉快！',
        };
    },
    created() {
        this.verification();
        this.type = this.$route.query.type ? this.$route.query.type : null;
        this.url = decodeURIComponent(decodeURIComponent(this.$route.query.url ? this.$route.query.url : null));
        this.name = this.$route.query.name ? this.$route.query.name : null;
        this.t = this.$route.query.t ? this.$route.query.t : null;
        this.userId = this.$route.query.userId ? this.$route.query.userId : null
    },
    methods: {
        verification() {
            let userinfo = JSON.parse(window.localStorage.getItem('ycUserinfos'));
            if (userinfo == null) {
                console.log('为空');
                this.$router.replace('/yclogin');
                return;
            }
        },
        async handleScoreSubmit() {
            let userinfo = JSON.parse(window.localStorage.getItem('ycUserinfos'));
            let user = JSON.parse(window.localStorage.getItem('userInfo'));
            if (this.isloading) {
                return
            }

            if (!this.scoreNumber) {
                this.$toast('请输入分数');
                return
            }
            //必须是数字
            if (!/^[0-9]*$/.test(this.scoreNumber)) {
                this.$toast('请输入1-100数字');
                return
            }
            if (this.scoreNumber > 100 || this.scoreNumber < 0) {
                this.$toast('分数不能大于100且不能小于0');
                return
            }
            if (!this.evaluationContent) {
                this.$toast('请输入评价内容');
                return
            }
            if (userinfo.userName == this.name) {
                this.$toast('您不能给自己评分哦');
                return
            }
            this.isloading = true
            addRatingScore({
                "content": this.evaluationContent,
                "postUrl": this.url,
                "score": this.scoreNumber,
                userName: userinfo.userName,
                passWord: userinfo.passWord,
                uuid: userinfo.uuid,
                userId: this.userId,
            }).then(res => {
                this.scoreNumber = null
                this.evaluationContent = ''
                this.$toast('评价成功');
                this.$router.replace(`/ratingList?type=1&url=${encodeURIComponent(encodeURIComponent(this.url))}&userId=${this.userId}`);
                this.isloading = false
            }).catch(err => {
                this.isloading = false
            })
        },
    },
};
</script>
<style lang="less" scoped>
.wrap {
    width: 100%;
    height: 100vh;
    background: #f8f8f8;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .scoreHead {
        width: 100%;
        font-size: 14px;
        color: #383838;
        opacity: 1;
        background: linear-gradient(180deg, #a1c4fd 0%, #c2e9fb 100%);
        padding: 14px 10px;
        display: flex;
        justify-content: space-between;
    }

    .scoreNum {
        display: flex;
        align-items: center;
        font-size: 14px;
        padding: 0 10px;

        .input {
            width: 100px;
            height: 35px;
            background: #fff;
            border-radius: 4px;
            margin: 0 6px;
            padding: 4px;
        }

        span {
            color: red;
        }
    }

    .scoreAddressTitle {
        font-size: 14px;
        padding: 0 10px;
    }

    .adressDesc {
        margin: 0 10px;
        box-sizing: border-box;
        padding: 10px;
        font-size: 14px;
        height: 90px;
        background: #fff;
        position: relative;
        border-radius: 8px;

        .descTip {
            font-size: 14px;
            color: red;
            position: absolute;
            right: 10px;
            bottom: 4px;
        }

        .areatext {
            padding: 0px;
            width: 100%;
        }
    }


}
</style>